import React from "react"

function SvgThankbear(props) {
  return (
    <svg
      viewBox="0 0 26.05 30.36"
      {...props}
    >
      <defs>
        <linearGradient
          id="thankbear_svg__b"
          x1={1298.4}
          x2={1646.1}
          y1={200}
          y2={200}
          gradientTransform="translate(19.879 57.015) scale(.06157)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#thankbear_svg__a"
        />
        <linearGradient id="thankbear_svg__a">
          <stop stopColor="#00214e" offset={0} />
        </linearGradient>
        <linearGradient
          id="thankbear_svg__c"
          x1={1298.4}
          x2={1646.1}
          y1={200}
          y2={200}
          gradientTransform="matrix(.59362 .34273 0 .59362 598.28 -423.3)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#thankbear_svg__a"
        />
      </defs>
      <g
        fill="#c8a9fa"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-96.588 -52.1)"
      >
        <circle cx={109.47} cy={58.189} r={5.729} />
        <path d="M98.027 72.061s-3.727-1.988.815-6.35 9.407-3.979 11.748-3.927c4.035-.18 16.128 3.844 10.647 10.141l-2.803-3.14H100.27zM102.82 81.453s2.607-2.446 3.11-2.829c.504-.382 1.62.248 3.512.264 1.996.017 2.688-.548 3.42-.429.732.119 2.648 2.9 3.615 3.087.968.188 4.997-5.357 2.267-6.503s-14.473-1.655-16.089-.686c-1.616.97-2.003 2.173-2.108 3.243-.105 1.07 2.273 3.853 2.273 3.853z" />
      </g>
      <g
        fill="#fff"
        stroke="url(#thankbear_svg__b)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.137}
        transform="translate(-96.588 -52.1)"
      >
        <path
          d="M99.896 63.894h20.263c.296 0 .533.274.533.615v11.083c0 .341-.237.616-.533.616H99.896c-.295 0-.533-.274-.533-.615V64.51c0-.341.238-.616.533-.616z"
          fillOpacity={0.484}
        />
        <path
          d="M99.862 63.942h20.263c.296 0 .533.274.533.615V75.64c0 .342-.237.616-.533.616H99.862c-.295 0-.533-.274-.533-.615V64.558c0-.341.238-.616.533-.616z"
          fillOpacity={0.516}
        />
        <path
          d="M99.829 63.991h20.263c.296 0 .533.274.533.615V75.69c0 .342-.237.616-.533.616H99.829c-.295 0-.533-.274-.533-.615V64.607c0-.341.238-.616.533-.616z"
          fillOpacity={0.548}
        />
        <path
          d="M99.796 64.039h20.263c.296 0 .533.274.533.615v11.083c0 .341-.237.616-.533.616H99.796c-.295 0-.533-.274-.533-.615V64.655c0-.341.238-.617.533-.616z"
          fillOpacity={0.581}
        />
        <path
          d="M99.763 64.087h20.263c.296 0 .533.274.533.615v11.083c0 .342-.237.616-.533.616H99.763c-.295 0-.533-.274-.533-.615V64.703c0-.341.238-.616.533-.616z"
          fillOpacity={0.613}
        />
        <path
          d="M99.73 64.135h20.263c.296 0 .533.274.533.615v11.083c0 .342-.237.616-.533.616H99.73c-.295 0-.533-.274-.533-.615V64.75c0-.341.238-.616.533-.616z"
          fillOpacity={0.645}
        />
        <path
          d="M99.663 64.231h20.263c.296 0 .533.274.533.615V75.93c0 .341-.237.616-.533.616H99.663c-.295 0-.533-.274-.533-.615V64.847c0-.342.238-.617.533-.616z"
          fillOpacity={0.71}
        />
        <path
          d="M99.63 64.279h20.263c.296 0 .533.274.533.615v11.083c0 .342-.237.616-.533.616H99.63c-.295 0-.533-.274-.533-.615V64.895c0-.341.238-.616.533-.616z"
          fillOpacity={0.742}
        />
        <path
          d="M99.597 64.327h20.263c.296 0 .533.274.533.615v11.083c0 .342-.237.616-.533.616H99.597c-.295 0-.533-.274-.533-.615V64.943c0-.341.238-.616.533-.616z"
          fillOpacity={0.774}
        />
        <path
          d="M99.564 64.376h20.263c.296 0 .533.274.533.615v11.083c0 .342-.237.616-.533.616H99.564c-.295 0-.533-.274-.533-.615V64.992c0-.341.238-.616.533-.616z"
          fillOpacity={0.806}
        />
        <path
          d="M99.531 64.424h20.263c.296 0 .533.274.533.615v11.083c0 .341-.237.616-.533.616H99.531c-.295 0-.533-.274-.533-.615V65.04c0-.342.238-.617.533-.616z"
          fillOpacity={0.839}
        />
        <path
          d="M99.497 64.472h20.263c.296 0 .533.274.533.615V76.17c0 .342-.237.616-.533.616H99.497c-.295 0-.533-.274-.533-.615V65.088c0-.341.238-.616.533-.616z"
          fillOpacity={0.871}
        />
        <path
          d="M99.464 64.52h20.263c.296 0 .533.274.533.615v11.083c0 .342-.237.616-.533.616H99.464c-.295 0-.533-.274-.533-.615V65.136c0-.341.238-.616.533-.616z"
          fillOpacity={0.903}
        />
        <path
          d="M99.431 64.568h20.263c.296 0 .533.274.533.615v11.083c0 .341-.237.616-.533.616H99.431c-.295 0-.533-.274-.533-.615V65.184c0-.341.238-.617.533-.616z"
          fillOpacity={0.935}
        />
        <path
          d="M99.398 64.616h20.263c.296 0 .533.274.533.615v11.083c0 .341-.237.616-.533.616H99.398c-.295 0-.533-.274-.533-.615V65.232c0-.341.238-.616.533-.616z"
          fillOpacity={0.968}
        />
      </g>
      <g strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.323}>
        <path
          d="M1374.6 84.244l195.35 112.79c2.848 1.644 5.14 5.616 5.14 8.904v106.85c0 3.289-2.292 4.613-5.14 2.968l-195.35-112.79c-2.848-1.644-5.14-5.615-5.14-8.904V87.212c0-3.289 2.292-4.612 5.14-2.968z"
          fill="#fff"
          stroke="url(#thankbear_svg__c)"
          transform="matrix(.10372 -.05988 0 .10372 -139.783 86.2)"
        />
        <g fill="none" stroke="#00214e">
          <path
            d="M1369.4 90.765c2.014 7.974 92.519 122.4 102.79 128.33 10.276 5.933 102.76 4.142 102.76-11.626M1453.5 199.44l-81.845.444M1491.1 221.9l81.678 94.194"
            transform="matrix(.10372 -.05988 0 .10372 -139.783 86.2)"
          />
        </g>
      </g>
      <g
        fill="#c8a9fa"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-96.588 -52.1)"
      >
        <g strokeWidth={0.176}>
          <circle cx={104.16} cy={54.458} r={2.195} />
          <circle cx={114.16} cy={54.295} r={2.195} />
          <circle cx={99.155} cy={70.529} r={2.195} />
          <circle cx={119.64} cy={70.529} r={2.195} />
        </g>
        <ellipse
          transform="rotate(-21.645)"
          cx={64.576}
          cy={110.22}
          rx={3.16}
          ry={3.77}
        />
        <ellipse
          transform="scale(-1 1) rotate(-21.645)"
          cx={-139.03}
          cy={29.375}
          rx={3.317}
          ry={3.957}
        />
      </g>
      <path
        d="M12.872 8.185l.746-1.448-1.753.09z"
        fill="#9d7ed5"
        stroke="#00214e"
        strokeWidth={0.253}
      />
      <g
        fill="#073984"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-96.588 -52.1)"
      >
        <ellipse
          transform="rotate(-21.645)"
          cx={64.332}
          cy={110.99}
          rx={1.955}
          ry={2.332}
        />
        <path d="M108.19 70.015c-.634.006-1.266.464-1.258 1.351.018 1.774 2.501 2.772 2.501 2.772s2.484-.998 2.502-2.772c.016-1.666-2.23-1.818-2.502-.304a1.221 1.221 0 00-1.243-1.047z" />
        <g strokeWidth={0.042} transform="rotate(-21.645)">
          <ellipse cx={65.472} cy={107.9} rx={0.475} ry={0.567} />
          <ellipse cx={64.159} cy={107.7} rx={0.475} ry={0.567} />
          <ellipse cx={62.854} cy={108.13} rx={0.475} ry={0.567} />
        </g>
        <ellipse
          transform="scale(-1 1) rotate(-21.645)"
          cx={-139.05}
          cy={30.28}
          rx={1.955}
          ry={2.332}
        />
        <g strokeWidth={0.042} transform="scale(-1 1) rotate(-21.645)">
          <ellipse cx={-137.91} cy={27.188} rx={0.475} ry={0.567} />
          <ellipse cx={-139.23} cy={26.986} rx={0.475} ry={0.567} />
          <ellipse cx={-140.53} cy={27.42} rx={0.475} ry={0.567} />
        </g>
      </g>
    </svg>
  )
}

export default SvgThankbear

